import Logger from '/@/modules/core/app/helpers/Logger';

/**
 * @deprecated
 */
export class ModelRelationshipProxy {
  /**
   * @type {Promise<ModelRelationship>|*}
   */
  proxy;

  async init() {
    try {
      const proxy = await import(`/@/modules/core/app/models/relationships/ModelRelationship`);
      this.proxy = new proxy.ModelRelationship();
    } catch (e) {
      Logger.error(e);
    }
  }

  async initForNode() {
    try {
      // eslint-disable-next-line global-require
      const path = require('path');
      const modelRelationshipPath = path.resolve(__dirname, './ModelRelationship');
      const proxy = await import(/* @vite-ignore */ modelRelationshipPath);
      this.proxy = new proxy.ModelRelationship();
    } catch (e) {
      Logger.error(e);
    }
  }
}

/**
 * @deprecated
 */
export default new ModelRelationshipProxy();
